// @flow
import React, { Component } from 'react';
import { Watch } from 'scrollmonitor-react';
import styles from '../../plugins/OfferList/styles.scss';
import eliteStyles from './styles.scss';
import { Container, Row, Col } from '../Grid';
import Price from '../Price';
import classNames from 'classnames';
import { MODAL_TYPES } from 'Containers/ContactForm/contactFormConstants';
import { withRouter } from 'react-router-dom';
import { withUrlParams } from 'Utils/withUrlParams';
import { exchangeLabelIfNecessary } from 'Utils/getButtonLabel';
import { getAdjustedModalType } from 'Utils/getModalType';
import FocusedImage from 'Components/FocusedImage';
import Button from 'Components/Button';
import Typography from 'Components/Typography';
import Gallery from 'Components/Gallery';
import Link from 'Components/Link';
import { formatPrice } from 'Utils';
import RichText from 'Components/RichText';

type Props = {
  alternateColors: boolean,
  background: string,
  hasForm?: () => void, // no in use
  id: any,
  isInViewport: boolean,
  offer: {
    copy: string,
    externalId: string,
    footnote: string,
    headline1: string,
    headline2: string,
    image: Object,
    modalType: string,
    price: string,
    priceInfo: string,
  },
  tireDataSheet: {
    href: string,
    label: string,
    enabled: boolean,
    image: Object,
  },

  onOpenContact?: () => void, // no in use
  setSharedState: () => void,
  sharedState: Object,
  stopWatcher?: () => void,
  updateMultipleUrlQuery: () => void,
};

class EliteServiceOffer extends Component<Props> {
  static getDerivedStateFromProps(props: Props) {
    if (props.isInViewport) {
      props.stopWatcher();
    }

    return null;
  }

  renderHeadline = (headline1, headline2, headlineLevel) => (
    <Row>
      <Col>
        <Typography.Headline
          level={headlineLevel ?? 'h2'}
          forceUppercase={true}
          className={eliteStyles.headline}
          ariaLabel={`${headline1} ${headline2 ?? ''}`.trim()}
          levelVisually="h3"
          value={
            <>
              {headline1} {headline2 && <span className={eliteStyles.break}>{headline2}</span>}
            </>
          }
        />
      </Col>
    </Row>
  );

  render() {
    const {
      alternateColors,
      background,
      id,
      isInViewport,
      offer,
      setSharedState,
      updateMultipleUrlQuery,
    } = this.props;

    const {
      copy,
      footnote,
      headline1,
      headline2,
      headlineLevel,
      image,
      modalType,
      price,
      priceInfo,
      tireDataSheet,
    } = offer;

    if (image) {
      image.alt = `${headline1} ${headline2}`;
    }

    const isOsbOffer = modalType === 'OSB';
    const { isOsbUser, isSalesPartner, isServicePartner } = window.dealer.settings;
    const adjustedModalType = getAdjustedModalType({
      isOsbUser,
      isSalesPartner,
      isServicePartner,
      initialModalType: isOsbOffer
        ? MODAL_TYPES.ONLINE_SERVICE_BOOKING.name
        : MODAL_TYPES.SERVICE_REQUEST.name,
    });
    const priceInfoText = priceInfo.slice(0, priceInfo.endsWith('€') ? -1 : priceInfo.length);
    const className = classNames(styles.entry, {
      [eliteStyles.entry]: true,
      [background]: true,
      [styles.isInViewport]: isInViewport || window.isPreview,
      [styles.alternateColors]: alternateColors,
    });

    return (
      <div className={className} id={id}>
        <Container>
          {this.renderHeadline(headline1, headline2, headlineLevel)}
          <Row align="center">
            <Col m={6}>
              <div className={classNames([styles.image, eliteStyles.image])}>
                <FocusedImage image={image} useThumb={'L'} />
              </div>
            </Col>

            <Col m={6}>
              <Row>
                <Col m={12} className={classNames([eliteStyles.text, styles.text])}>
                  <RichText content={copy} />
                </Col>

                {tireDataSheet?.enabled && (
                  <>
                    <Col m={6}>
                      {tireDataSheet.label && tireDataSheet.url && (
                        <Link
                          className={eliteStyles.link}
                          label={tireDataSheet.label}
                          to={tireDataSheet.url}
                          buttonVariant="secondary"
                        />
                      )}
                      <br />
                      <br />
                    </Col>
                    <Col m={6} className={classNames([styles.priceWrapper])}>
                      {tireDataSheet?.image && (
                        <Gallery
                          images={[
                            { src: tireDataSheet.image.thumbnails['600x600'], alt: 'Reifenlabel' },
                          ]}
                          fullscreen={false}
                          openImageInModal={true}
                        />
                      )}
                    </Col>
                  </>
                )}

                <Col m={12} className={classNames([styles.priceWrapper, eliteStyles.priceWrapper])}>
                  <div className={eliteStyles.priceInfoWrapper}>
                    <div
                      className={eliteStyles.priceInfo}
                      dangerouslySetInnerHTML={{
                        __html: priceInfoText,
                      }}
                    />
                    {priceInfo.toLowerCase() === 'kostenlos' || !price ? (
                      ''
                    ) : (
                      <Price value={formatPrice(price)} showZero dark />
                    )}
                  </div>
                </Col>

                <Col m={12} className={classNames([styles.priceWrapper, eliteStyles.priceWrapper])}>
                  <div
                    className={eliteStyles.price}
                    dangerouslySetInnerHTML={{
                      __html: footnote,
                    }}
                  />
                </Col>

                <div className={eliteStyles.buttonwrapper}>
                  <Button
                    small
                    label={exchangeLabelIfNecessary('---', adjustedModalType)}
                    trackingLabel={`Werkstattterminanfrage Angebot: ${headline1} ${headline2}`}
                    ariaLabel={`${exchangeLabelIfNecessary('---', adjustedModalType)} - Werkstattterminanfrage Angebot: ${headline1} ${headline2}`}
                    onClick={() => {
                      setSharedState('serviceangebot', `${headline1} ${headline2}`);
                      updateMultipleUrlQuery({
                        modaltype: isOsbOffer
                          ? MODAL_TYPES.ONLINE_SERVICE_BOOKING.name
                          : MODAL_TYPES.SERVICE_REQUEST.name,
                        showmodal: 'true',
                      });
                    }}
                  />
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(withUrlParams(Watch(EliteServiceOffer)));
